module.exports = new __parcel__URL__("chrome-icon.40414d4b.svg").toString();